"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = require("react");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _sizes = require("HubStyleTokens/sizes");

var _Styles = require("../utils/Styles");

var _PopoverContext = require("../context/PopoverContext");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background: inherit;\n  border-radius: inherit;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  padding: ", ";\n  text-align: ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var handlePadding = function handlePadding(hasStructuredFooter, popoverUse) {
  if (popoverUse !== 'shepherd') return _sizes.POPOVER_PADDING_Y + " " + _sizes.POPOVER_PADDING_X;
  var paddingTop = hasStructuredFooter ? (0, _Styles.toPx)(parseInt(_sizes.POPOVER_PADDING_X, 10) - parseInt(_sizes.SHEPHERD_PADDING_Y, 10)) : '0px';
  var paddingBottom = hasStructuredFooter ? _sizes.POPOVER_PADDING_Y : _sizes.SHEPHERD_PADDING_Y;
  return paddingTop + " " + _sizes.POPOVER_PADDING_X + " " + paddingBottom + " " + _sizes.POPOVER_PADDING_X;
};

var UIPopoverFooter = _styledComponents.default.footer.attrs({
  className: 'uiPopoverFooter private-popover__footer'
}).withConfig({
  displayName: "UIPopoverFooter",
  componentId: "sc-1kc32rr-0"
})(_templateObject(), function (_ref) {
  var flush = _ref.flush,
      hasStructuredFooter = _ref.hasStructuredFooter,
      popoverContext = _ref.popoverContext;
  return flush ? '0' : handlePadding(hasStructuredFooter, popoverContext.use);
}, function (_ref2) {
  var align = _ref2.align;
  return align;
}, function (_ref3) {
  var hasStep = _ref3.hasStep;
  return hasStep ? (0, _styledComponents.css)(_templateObject2()) : null;
});

UIPopoverFooter.propTypes = {
  align: _react.PropTypes.oneOf(['left', 'right']).isRequired,
  children: _react.PropTypes.node,
  flush: _react.PropTypes.bool,
  hasStep: _react.PropTypes.bool,
  hasStructuredFooter: _react.PropTypes.bool,
  popoverContext: _PopoverContext.popoverContextPropType
};
UIPopoverFooter.defaultProps = {
  align: 'left',
  hasStructuredFooter: false,
  hasStep: false
};
UIPopoverFooter.displayName = 'UIPopoverFooter';

var _default = (0, _PopoverContext.ConsumesPopoverContext)(UIPopoverFooter);

exports.default = _default;
module.exports = exports.default;